import React from 'react';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkButtonSize, UitkPrimaryButton } from 'uitk-react-button';
import { UitkLayoutPosition } from 'uitk-react-layout-position';
import { useBexApi } from '@shared-ui/bex-api-context';
import {
  CustomerSurveyButtonFragment,
  CustomerSurveyLinkFragment,
  useCustomerSurveyQuery,
} from '../../graphql/__generated__/types';
import useNavigationParams from '../../hooks/useNavigationParams';
import { ViewLarge, Viewport, ViewSmall } from '@shared-ui/viewport-context';

const CustomerSurvey = () => {
  const { context } = useBexApi();
  const { hubId } = useNavigationParams();
  const { data, loading, error } = useCustomerSurveyQuery({ variables: { hubId, context } });

  const openPopup = (popupUrl: string) => (e: React.MouseEvent | React.KeyboardEvent) => {
    const height = 650;
    const width = 600;
    const top = window.outerHeight / 2 + window.screenY - height / 2;
    const left = window.outerWidth / 2 + window.screenX - width / 2;

    const queryParams = [
      { key: 'url', value: window.location.href },
      { key: 'duaid', value: context.identity.duaid },
    ];

    const queryString = queryParams
      .filter(({ value }) => value)
      .map(({ key, value }) => `${key}=${encodeURI(value)}`)
      .join('&');

    const surveyUrl = `${popupUrl}/?${queryString}`;

    const popupParams = [
      `toolbar=no`,
      `scrollbars=no`,
      `location=no`,
      `statusbar=no`,
      `menubar=no`,
      `resizable=no`,
      `width=${width}px`,
      `height=${height}px`,
      `left=${left}`,
      `top=${top}`,
    ].join(',');
    e.stopPropagation();

    const popup = window.open(surveyUrl, '', popupParams);
    popup?.focus();
  };
  const openPopupOnKeyDown = (popupUrl: string) => (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      openPopup(popupUrl)(e);
    }
  };

  if (loading || error || !data) return null;

  const customerSurveyButton = data?.documentation?.customerSurvey?.button as CustomerSurveyButtonFragment;
  const surveyUrl = (customerSurveyButton.action as CustomerSurveyLinkFragment).resource.value;

  return (
    <Viewport>
      <ViewLarge>
        <UitkLayoutPosition type="absolute" position={{ bottom: 'six', right: 'six' }}>
          <UitkPrimaryButton
            className="feedback-button__button"
            onClick={openPopup(surveyUrl)}
            onKeyDown={openPopupOnKeyDown(surveyUrl)}
          >
            <UitkIcon name={customerSurveyButton.icon.token} />
            {customerSurveyButton.primary}
          </UitkPrimaryButton>
        </UitkLayoutPosition>
      </ViewLarge>
      <ViewSmall>
        <UitkLayoutPosition type="absolute" position={{ bottom: 'three', right: 'three' }}>
          <UitkPrimaryButton
            size={UitkButtonSize.SMALL}
            onClick={openPopup(surveyUrl)}
            onKeyDown={openPopupOnKeyDown(surveyUrl)}
          >
            <UitkIcon name={customerSurveyButton.icon.token} size={UitkIconSize.SMALL} />
            {customerSurveyButton.primary}
          </UitkPrimaryButton>
        </UitkLayoutPosition>
      </ViewSmall>
    </Viewport>
  );
};

export default CustomerSurvey;
